export default "__VITE_ASSET__PLHt2iSc__"